import { InstagramIcon } from '@change/ds-icons';

import { Image, SocialIcon } from '@change/ds-core-ui/next';

import type { Platform } from '../../../../shared/constants/platformConfig';
import { SocialContentPreviewLoading } from '../SocialContentPreviewLoading';

type SocialContentPreviewProps = Readonly<{
	shareVisual?: {
		url: string;
		variationName: string;
	};
	isLoading: boolean;
	platform?: Platform;
}>;

export function SocialContentPreview({ shareVisual, isLoading, platform }: SocialContentPreviewProps) {
	if (isLoading || !shareVisual) {
		return <SocialContentPreviewLoading platform={platform} />;
	}

	return (
		<div className="relative h-[170px] w-[136px]">
			<SocialIcon
				aria-label="Instagram"
				icon={<InstagramIcon />}
				size="medium"
				variant="instagram"
				className="absolute -right-[5px] -top-[5px] border border-white"
				data-testid="instagram-icon"
			/>
			<Image src={shareVisual.url} alt={shareVisual.variationName} className="h-full w-full rounded-lg object-cover" />
		</div>
	);
}
